import { Router } from '@vaadin/router';
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import '@vaadin/vaadin-icons/vaadin-icons.js';
import "./kb-folderitem.js";

class KbFolders extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.state = storeInstance.state
        this.string = this.state.strings;
        if(this.rootnode){
            this.myRender()
           }
        }

    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
        }


    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
        if(this.rootnode){
            this.myRender()
            }
        }
    
   

    myRender(){
        render(this.tocItemTemplate(), this.shadowRoot);
        }
       
    tocItemTemplate(){
       return html`
            <style>
                #iconspan{
                    display:inline-block;width:20px;
                }
                #toccontainer{
                    padding:.5rem;
                }
            </style>
            <div id='toccontainer'>
                ${this.rootnode.children ? this.rootnode.children.map((node)=> html`<kb-folderitem .node="${node}"></kb-folderitem>`) : html``}
            <div>
           `;
        }
    
        _icon(){
        if(this.node.children){
            if(this.node.open){
                    return html`<iron-icon icon="vaadin:angle-down" @click="${this._toggleNode}"></iron-icon>`;
                } else {
                    return html`<iron-icon icon="vaadin:angle-right"></iron-icon>`;
                }
        } else {
            return html`&nbsp;`
           }
    }

   



}

customElements.define('kb-folders', KbFolders)
